// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uKvx6","label":"styles_label__1ZFv1"};